/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots8VIcon20Solid = forwardRef('UiMenuDots8VIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.5 4.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z" }),
        React.createElement("path", { d: "M7.5 9.333a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z" }),
        React.createElement("path", { d: "M9.25 12.416a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z" }),
        React.createElement("path", { d: "M7.5 19a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z" }),
        React.createElement("path", { d: "M14.25 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z" }),
        React.createElement("path", { d: "M12.5 9.333a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z" }),
        React.createElement("path", { d: "M14.25 12.416a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z" }),
        React.createElement("path", { d: "M12.5 19a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z" })));
});
